var breakPoints = {
  xl: 1680,
  lg: 1196,
  md: 1024,
  sm: 640,
  xs: 1 // 0 is falsy (can't do null-checks as we do below if we set xs: 0)
};

var breakPointsMin = {
  xl: breakPoints.xl,
  lg: breakPoints.lg,
  md: breakPoints.md,
  sm: breakPoints.sm,
  xs: breakPoints.xs
};
var breakPointsMax = {
  // See https://getbootstrap.com/docs/4.0/layout/overview/#responsive-breakpoints
  // The maximum value is calculated as the minimum of the next one less 0.02px to work around the limitations
  // of `min-` and `max-` prefixes and viewports with fractional widths.
  // See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
  // Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
  lg: breakPoints.xl - 0.02,
  md: breakPoints.lg - 0.02,
  sm: breakPoints.md - 0.02,
  xs: breakPoints.sm - 0.02
};
function getViewportMediaQueryRange(minViewport, maxViewport) {
  return [minViewport && "(min-width: ".concat(breakPointsMin[minViewport], "px)"), maxViewport && breakPointsMax[maxViewport] && "(max-width: ".concat(breakPointsMax[maxViewport], "px)")].filter(function (x) {
    return !!x;
  }).join(" and ");
}
function getViewportMediaQuery(viewport, direction) {
  var min = direction === "min" || direction === "exact" ? breakPointsMin[viewport] : undefined;
  var max = direction === "max" || direction === "exact" ? breakPointsMax[viewport] : undefined;
  return [min ? "(min-width: ".concat(min, "px)") : "", max ? "(max-width: ".concat(max, "px) ") : ""].filter(function (mq) {
    return !!mq;
  }).join(" and ");
}
var getViewportMediaQuerySmMin = function getViewportMediaQuerySmMin() {
  return getViewportMediaQuery("sm", "min");
};
var getViewportMediaQueryMdMin = function getViewportMediaQueryMdMin() {
  return getViewportMediaQuery("md", "min");
};
var getViewportMediaQueryLgMin = function getViewportMediaQueryLgMin() {
  return getViewportMediaQuery("lg", "min");
};
var getViewportMediaQueryXlMin = function getViewportMediaQueryXlMin() {
  return getViewportMediaQuery("xl", "min");
};
var getViewportMediaQueryXsExact = function getViewportMediaQueryXsExact() {
  return getViewportMediaQuery("xs", "exact");
};

export { breakPoints, getViewportMediaQuery, getViewportMediaQueryLgMin, getViewportMediaQueryMdMin, getViewportMediaQueryRange, getViewportMediaQuerySmMin, getViewportMediaQueryXlMin, getViewportMediaQueryXsExact };
